import { render, staticRenderFns } from "./ProgramStats.vue?vue&type=template&id=02a6da41&"
import script from "./ProgramStats.vue?vue&type=script&lang=js&"
export * from "./ProgramStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports